var generateStyle = function generateStyle(componentTheme) {
  return {
    wrapper: {
      position: 'relative',
      width: '100%',
      boxSizing: 'border-box',
      marginBottom: componentTheme.wrapperMargin,
      display: 'flex',
      alignItems: 'center',
      paddingTop: componentTheme.wrapperPadding,
      paddingLeft: componentTheme.wrapperPadding
    },
    text: {
      fontSize: componentTheme.textFontSize
    }
  };
};
export default generateStyle;